var Shopify = Shopify || {};
/* ======================================================================
   COLLECT ALL SHOPIFY SECTION IDs
   ====================================================================== */
document.addEventListener('DOMContentLoaded', function () {

  const sectionIds = [];
  const sectionElements = document.querySelectorAll('[id^="shopify-section-"]');

  sectionElements.forEach(section => {
    const fullId = section.id;                        // shopify-section-123456
    const sectionId = fullId.replace('shopify-section-', '');
    sectionIds.push(sectionId);
  });

  // console.log("Loaded all Shopify Sections List:", sectionIds);
});






// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/* ======================================================================
   Search POPUP OPEN CODE
   ====================================================================== */

document.addEventListener("DOMContentLoaded", function () {
  const openBtn = document.querySelector(".search-drawer_popup");
  const closeBtn = document.querySelector(".search_popup_close");
  const popupWrapper = document.querySelector(".search_popup_wrapper");
  const popupInner = popupWrapper
    ? popupWrapper.querySelector(".search_popup_inner")
    : null;

  const html = document.documentElement;
  const body = document.body;

  if (!openBtn || !closeBtn || !popupWrapper || !popupInner) return;

  let lastFocusedElement = null;

  // Get all focusable elements inside popup
  function getFocusableElements() {
    return popupInner.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
    );
  }

  function openSearchPopup() {
    lastFocusedElement = document.activeElement;

    // Lock scroll
    html.classList.add("lenis", "lenis-stopped");
    body.setAttribute("data-scroll-locked", "true");

    // Show popup
    popupWrapper.classList.add("serach_active");
    popupWrapper.setAttribute("aria-hidden", "false");

    // Wait for CSS transition / visibility
    requestAnimationFrame(() => {
      const focusable = getFocusableElements();
      if (focusable.length) {
        focusable[0].focus();
      } else {
        popupInner.setAttribute("tabindex", "-1");
        popupInner.focus();
      }
    });
  }

  function closeSearchPopup() {
    // Unlock scroll
    html.classList.remove("lenis-stopped");
    body.removeAttribute("data-scroll-locked");

    // Hide popup
    popupWrapper.classList.remove("serach_active");
    popupWrapper.setAttribute("aria-hidden", "true");

    // Restore focus
    if (lastFocusedElement) {
      lastFocusedElement.focus();
    }
  }

  function trapFocus(e) {
    if (!popupWrapper.classList.contains("serach_active")) return;

    const focusable = getFocusableElements();
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.key === "Tab") {
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  //  Outside click close (outside INNER only)
  function handleOutsideClick(e) {
    if (
      popupWrapper.classList.contains("serach_active") &&
      !popupInner.contains(e.target) &&
      !openBtn.contains(e.target)
    ) {
      closeSearchPopup();
    }
  }

  // Open popup
  openBtn.addEventListener("click", function (e) {
    e.preventDefault();
    openSearchPopup();
  });

  // Close popup
  closeBtn.addEventListener("click", function (e) {
    e.preventDefault();
    closeSearchPopup();
  });

  // Keyboard handling
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && popupWrapper.classList.contains("serach_active")) {
      closeSearchPopup();
    }
    trapFocus(e);
  });

  // Outside click listeners
  document.addEventListener("mousedown", handleOutsideClick);
  document.addEventListener("touchstart", handleOutsideClick);
});





/* ======================================================================
   ANNOUNCEMENT BAR SLIDER WEB COMPONENT
   ====================================================================== */
class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Check if multiple slides exist
    const hasMultipleSlides = this.querySelectorAll(
      ".announcement-bar__item.swiper-slide"
    ).length > 1;

    if (!hasMultipleSlides) return;

    // Read data attributes
    const autoplay = this.dataset.autoplay === "true";
    const speed = parseInt(this.dataset.autoplaySpeed * 1000) || 3000;
    const fade = this.dataset.fade;
    let effect = fade === "true" ? "fade" : "slide";

    // Initialize Swiper
    const swiperContainer = this.querySelector(
      ".announcement-bar__inner.announcement-bar__inner--multiple"
    );

    if (!swiperContainer) return;

    whenSwiperReady(() => {
    new Swiper(swiperContainer, {
      loop: true,
      speed: 1000,
      grabCursor: true,
      autoplay: autoplay
        ? { delay: speed, disableOnInteraction: false }
        : false,
      effect: effect,
      fadeEffect: { crossFade: true },
      breakpoints: {
        0: { slidesPerView: 1, spaceBetween: 20 },
        640: { slidesPerView: 1 },
      },
    });
    });
  }
}

// Define custom element
customElements.define("announcement-bar", AnnouncementBar);


/* ======================================================================
    SLIDESHOW SLIDER WEB COMPONENT
   ====================================================================== */
class SlideshowSlider extends HTMLElement {
  constructor() {
    super();

    /* ===============================
       DATA ATTRIBUTES
    ================================ */
    this.sectionId = this.dataset.sectionId || "";
    this.spacing = Number(this.dataset.spacing) || 0;
    this.autoplay = this.dataset.autoplay === "true";
    this.speed = Number(this.dataset.autoplaySpeed) * 1000 || 3000;
    this.effect = this.dataset.effect || "slide";

    /* ===========  SELECTORS (UPDATED) ========== */
    this.slider = this.querySelector(
      `.hero-slideshow__slider--${this.sectionId}`
    );

    this.nextBtn = this.querySelector(
      `.hero-slideshow__next--${this.sectionId}`
    );

    this.prevBtn = this.querySelector(
      `.hero-slideshow__prev--${this.sectionId}`
    );

    this.paginationEl = this.querySelector(
      `.swiper-pagination--${this.sectionId}`
    );

  }

  connectedCallback() {
    if (!this.slider) {
      console.warn(
        `Swiper container missing for section: ${this.sectionId}`
      );
      return;
    }

    /* =========== INIT SWIPER ================ */
    whenSwiperReady(() => {
      this.swiper = new Swiper(this.slider, {
        slidesPerView: 1,
        spaceBetween: this.spacing,
        speed: 800,
        effect: this.effect,

        autoplay: this.autoplay
          ? {
              delay: this.speed,
              disableOnInteraction: true,
              pauseOnMouseEnter: true,
            }
          : false,

        navigation:
          this.nextBtn && this.prevBtn
            ? {
                nextEl: this.nextBtn,
                prevEl: this.prevBtn,
              }
            : false,
            
        pagination:
          this.paginationEl
            ? {
                el: this.paginationEl,
                clickable: true,
              }
            : false,
      });
    });
    // console.log(`Swiper initialized for section: ${this.sectionId}`);
  }
  
}

customElements.define("slideshow-slider", SlideshowSlider);




/* ======================================================================
    Collection Slider WEB COMPONENT
   ====================================================================== */


class CollectionSlider extends HTMLElement {
  constructor() {
    super();

    this.autoplayEnabled = this.dataset.autoplay === "true";
    this.autoplaySpeed = Number(this.dataset.autoplaySpeed) * 1000 || 3000;
    this.effect = this.dataset.effect || "slide";

    this.slider = this.querySelector(".collection_slider_blocks_wrapper");
    this.wrapper = this.querySelector(".swiper-wrapper");
    this.mobileSlides = Number(this.dataset.mobileSlide) || 3;
    this.swiper = null;
  }

  connectedCallback() {
    if (!this.slider || !this.wrapper) return;
    if (this.swiper) return; //  prevent double init

    const totalSlides = this.wrapper.children.length;
    const isMobile = window.innerWidth < 1200;

    // Optional: avoid slider init if too few slides
    if (!isMobile && totalSlides < 12) return;

    whenSwiperReady(() => {
      this.swiper = new Swiper(this.slider, {
        speed: 800,
        spaceBetween: 5,
        effect: this.effect,

        //  A11Y FIX — NO LOOP
        loop: false,

        autoplay: this.autoplayEnabled
          ? {
              delay: this.autoplaySpeed,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          : false,

        navigation: false,
        pagination: false,

        breakpoints: {
          0: { slidesPerView: this.mobileSlides },
          640: { slidesPerView: this.mobileSlides },
          768: { slidesPerView: 5 },
          990: { slidesPerView: 8 },
          1024: { slidesPerView: 8 },
          1200: { slidesPerView: 12 },
          1400: { slidesPerView: 12 },
        },
      });
    });
  }
}

customElements.define("collection-slider", CollectionSlider);




/* ======================================================================
    Before After WEB COMPONENT
   ====================================================================== */

    try {
    class SectionScaler extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            const vh = window.innerHeight,
                totalSlides = parseInt(this.dataset.totalInners, 10);
            let currentValue = 0,
                targetValue = 0,
                rafId = null;
            const updateInertia = () => {
                    (currentValue += (targetValue - currentValue) * 0.05),
                        this.style.setProperty("--animate-value", currentValue.toFixed(3)),
                        (rafId = requestAnimationFrame(updateInertia));
                },
                handleScroll = () => {
                    const sectionTop = this.offsetTop;
                    let section = (window.scrollY - sectionTop) / vh;
                    (section = Math.max(0, Math.min(section, totalSlides))), (targetValue = section);
                };
            (this.observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        entry.isIntersecting
                            ? (window.addEventListener("scroll", handleScroll, { passive: !0 }),
                              rafId || (rafId = requestAnimationFrame(updateInertia)))
                            : (window.removeEventListener("scroll", handleScroll),
                              rafId && (cancelAnimationFrame(rafId), (rafId = null)));
                    });
                },
                { root: null, rootMargin: "-10% 0px 0px 0px", threshold: 0 }
            )),
                this.observer.observe(this);
        }
    }
    customElements.get("section-scaler") || customElements.define("section-scaler", SectionScaler);
    } catch (e) {
    console.error(e);
    }
     
    

/* ======================================================================
    Tag Filter Section WEB COMPONENT
   ====================================================================== */
   
class TagFilterCode extends HTMLElement {
  constructor() {
    super();

    this.sectionId = this.dataset.sectionId;

    this.filterBtn = this.querySelector(
      `#tagFilterBtn-${this.sectionId}`
    );

    this.dropdown1 = this.querySelector(
      `#tagDropdown1-${this.sectionId}`
    );

    this.dropdown2 = this.querySelector(
      `#tagDropdown2-${this.sectionId}`
    );
  }

  connectedCallback() {
    if (!this.filterBtn || !this.dropdown1 || !this.dropdown2) return;

    this.filterBtn.addEventListener("click", () => {
      const tag1 = this.dropdown1.value;
      const tag2 = this.dropdown2.value;

      if (!tag1 && !tag2) return;

      let url = "/collections/all";

      if (tag1 && tag2) {
        url += `/${tag1}+${tag2}`;
      } else if (tag1) {
        url += `/${tag1}`;
      } else if (tag2) {
        url += `/${tag2}`;
      }

      window.location.href = url;
    });
  }
}

customElements.define("tag-filter-code", TagFilterCode);



/* ======================================================================
    VIDEO  Section WEB COMPONENT
   ====================================================================== */

class VideoSection extends HTMLElement {
  constructor() {
    super();

    this.playIcon = this.querySelector(".play_icon_wrapper");

    this.imageContainer = this.querySelector(
      ".video_section_poster_image_wrapper"
    );

    this.videoContainer = this.querySelector(".video_section_video_wrapper");
    this.video = this.videoContainer?.querySelector("video");
    this.iframe = this.videoContainer?.querySelector("iframe");
  }

  connectedCallback() {
    if (this.playIcon && this.imageContainer && this.videoContainer) {
      this.playIcon.addEventListener("click", this.handleClick);
    }
  }

  disconnectedCallback() {
    this.playIcon?.removeEventListener("click", this.handleClick);
  }

  handleClick = () => {
    if (!this.video && !this.iframe) return;

    this.imageContainer.classList.add("nodisp");

    setTimeout(() => {
      this.imageContainer.style.display = "none";
      this.videoContainer.style.display = "block";
      requestAnimationFrame(() => this.videoContainer.classList.add("disp"));

      if (this.video) {
        this.video.play();
      } else if (this.iframe) {
        const src = this.iframe.getAttribute("src");
        if (src.includes("youtube.com") || src.includes("youtu.be")) {
          this.iframe.contentWindow.postMessage(
            '{"event":"command","func":"playVideo","args":""}',
            "*"
          );
        } else if (src.includes("vimeo.com")) {
          this.iframe.contentWindow.postMessage(
            '{"method":"play"}',
            "https://player.vimeo.com"
          );
        }
      }
    }, 500);
  };
}
customElements.define("video-section-block", VideoSection);

/* ======================================================================
    Review Slider Section WEB COMPONENT
   ====================================================================== */

   class ReviewSlider extends HTMLElement {
  constructor() {
    super();

    /* ===============================
       SECTION ID
    ================================ */
    this.sectionId = this.dataset.sectionId;

    /* ===============================
       SELECTORS (SCOPED)
    ================================ */
    this.slider = this.querySelector(
      `.review_row--${this.sectionId}`
    );

    this.pagination = this.querySelector(
      `.swiper-pagination--${this.sectionId}`
    );

    this.nextBtn = this.querySelector(
      `.review_buttonNext--${this.sectionId}`
    );

    this.prevBtn = this.querySelector(
      `.review_buttonPrev--${this.sectionId}`
    );
  }

  connectedCallback() {
    if (!this.slider) return;

  whenSwiperReady(() => {
    this.swiper = new Swiper(this.slider, {
      effect: "cards",
      grabCursor: true,

      cardsEffect: {
        rotate: true,
        perSlideRotate: 4,
        perSlideOffset: 5,
        slideShadows: false,
      },

      pagination: this.pagination
        ? {
            el: this.pagination,
            clickable: true,
          }
        : false,

      navigation:
        this.nextBtn && this.prevBtn
          ? {
              nextEl: this.nextBtn,
              prevEl: this.prevBtn,
            }
          : false,

      initialSlide: 3,
      speed: 500,
    });
    });
  }
}

customElements.define("review-slider", ReviewSlider);


/* ======================================================================
    Product Tab Slider WEB COMPONENT
   ====================================================================== */

  class ProductTabSlider extends HTMLElement {
  constructor() {
    super();

    this.sectionId = this.dataset.sectionId;

    this.thumbSlider = this.querySelector(
      `.productTab__steps_follow--${this.sectionId}`
    );

    this.mainSlider = this.querySelector(
      `.product_tab_slides--${this.sectionId}`
    );

    this.nextBtn = this.querySelector(
      `.productTab_button_next--${this.sectionId}`
    );

    this.prevBtn = this.querySelector(
      `.productTab_button_prev--${this.sectionId}`
    );
  }

  connectedCallback() {
    if (!this.thumbSlider || !this.mainSlider) return;

    whenSwiperReady(() => {
    this.thumbSwiper = new Swiper(this.thumbSlider, {
      spaceBetween: 20,
      slidesPerView: 8,
      freeMode: true,
      grabCursor: true,
      watchSlidesProgress: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: this.nextBtn,
        prevEl: this.prevBtn,
      },
      breakpoints: {
        320: {
          slidesPerView: 4,
          spaceBetween: 10,
        },
        640: {
          slidesPerView: 5,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 6,
          spaceBetween: 15,
        },
      },
    });

    this.mainSwiper = new Swiper(this.mainSlider, {
      spaceBetween: 20,
      slidesPerView: 1,
      centeredSlides: true,
      autoHeight: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      thumbs: {
        swiper: this.thumbSwiper,
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
    });
    });
  }
}

customElements.define("product-tab-slider", ProductTabSlider);

   
/* ======================================================================
    Product Recommend filter Section WEB COMPONENT
   ====================================================================== */
  
class TagBasedRecommendation {
  constructor(sectionId) {

    /* ===============================
       DATA
    ================================ */
    this.sectionId = sectionId;
    this.section = document.querySelector(
      `[data-section-id="${sectionId}"]`
    );

    if (!this.section) return;

    /* ===============================
       ELEMENTS
    ================================ */
    this.dropdown1 = this.section.querySelector('[data-tag-dropdown="1"]');
    this.dropdown2 = this.section.querySelector('[data-tag-dropdown="2"]');
    this.button = this.section.querySelector('[data-tag-filter-btn]');

    if (!this.button) return;

    /* ===============================
       EVENTS
    ================================ */
    this.button.addEventListener('click', () => {
      this.handleRedirect();
    });
  }

  handleRedirect() {
    const tag1 = this.dropdown1?.value || '';
    const tag2 = this.dropdown2?.value || '';

    if (!tag1 && !tag2) return;

    let url = '/collections/all';

    if (tag1 && tag2) {
      url += `/${tag1}+${tag2}`;
    } else if (tag1) {
      url += `/${tag1}`;
    } else if (tag2) {
      url += `/${tag2}`;
    }

    window.location.href = url;
  }
}

document.querySelectorAll('[data-section-id]').forEach(section => {
  new TagBasedRecommendation(section.dataset.sectionId);
});

/* ======================================================================
    Product Card Slider Block COMPONENT
   ====================================================================== */

// function initProductCardSliders(scope = document) {
//   whenSwiperReady(() => {
//   const productCards = scope.querySelectorAll('[data-product-media-slider]');

//   if (!productCards.length) return;

//   productCards.forEach(function (card) {
//     const swiperEl = card.querySelector('.product-card-swiper');
//     const slides = swiperEl ? swiperEl.querySelectorAll('.swiper-slide') : [];
//     const thumbs = card.querySelectorAll('.product-thumb');

//     const prevBtn = card.querySelector('.product-card-prev');
//     const nextBtn = card.querySelector('.product-card-next');

//     // No slider needed → no errors
//     if (!swiperEl || slides.length < 2) {
//       if (prevBtn) prevBtn.style.display = 'none';
//       if (nextBtn) nextBtn.style.display = 'none';
//       return;
//     }

//     if (swiperEl.swiper) {
//       swiperEl.swiper.destroy(true, true);
//       swiperEl.swiper = null;
//     }

//     const swiper = new Swiper(swiperEl, {
//       effect: 'fade',
//       fadeEffect: {
//         crossFade: true
//       },
//       speed: 350,
//       slidesPerView: 1,
//       allowTouchMove: true,
//       watchSlidesProgress: true,
//       a11y: {
//         enabled: true
//       },
//       navigation: {
//         prevEl: prevBtn,
//         nextEl: nextBtn
//       }
//     });

    

//     // Thumbnail click
//     thumbs.forEach((thumb) => {
//       thumb.addEventListener('click', function () {
//         const index = Number(this.dataset.thumbIndex);
//         swiper.slideTo(index);

//         thumbs.forEach(t => {
//           t.classList.remove('is-active');
//           t.setAttribute('aria-selected', 'false');
//         });

//         this.classList.add('is-active');
//         this.setAttribute('aria-selected', 'true');
//       });
//     });

//     // Sync active thumb
//     swiper.on('slideChange', function () {
//       thumbs.forEach(t => {
//         t.classList.remove('is-active');
//         t.setAttribute('aria-selected', 'false');
//       });

//       if (thumbs[swiper.activeIndex]) {
//         thumbs[swiper.activeIndex].classList.add('is-active');
//         thumbs[swiper.activeIndex].setAttribute('aria-selected', 'true');
//       }
//     });
//   });
//    });
// }

function initProductCardSliders(scope = document) {

  whenSwiperReady(() => {

    const productCards = scope.querySelectorAll('[data-product-media-slider], [data-product-media-slider_main]');
    if (!productCards.length) return;

    productCards.forEach((card) => {

      const swiperEl = card.querySelector('.product-card-swiper');
      if (!swiperEl) return;

      const slides = swiperEl.querySelectorAll('.swiper-slide');

      const prevBtn = card.querySelector('.product-card-prev');
      const nextBtn = card.querySelector('.product-card-next');

      const productCard = card.closest('product-card');
      const thumbs = productCard ? productCard.querySelectorAll('.product-thumb') : [];

      // Hide navigation if only 1 image
      if (slides.length < 2) {
        if (prevBtn) prevBtn.style.display = 'none';
        if (nextBtn) nextBtn.style.display = 'none';
        return;
      }

      // Prevent double initialization
      if (swiperEl.classList.contains('swiper-initialized')) return;

      const swiper = new Swiper(swiperEl, {
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        speed: 350,
        slidesPerView: 1,
        allowTouchMove: true,
        watchSlidesProgress: true,
        a11y: {
          enabled: true
        },
        navigation: {
          prevEl: prevBtn,
          nextEl: nextBtn
        }
      });

      /* ===============================
         Thumbnail Click
      =============================== */

      thumbs.forEach((thumb) => {

        thumb.addEventListener('click', function () {

          const index = Number(this.dataset.thumbIndex);

          swiper.slideTo(index);

          thumbs.forEach(t => {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });

          this.classList.add('is-active');
          this.setAttribute('aria-selected', 'true');

        });

      });

      /* ===============================
         Sync active thumb with slider
      =============================== */

      swiper.on('slideChange', function () {

        thumbs.forEach(t => {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });

        if (thumbs[swiper.activeIndex]) {
          thumbs[swiper.activeIndex].classList.add('is-active');
          thumbs[swiper.activeIndex].setAttribute('aria-selected', 'true');
        }

      });

    });

  });

}



/* ======================================================================
    Featured collection Section WEB COMPONENT
   ====================================================================== */


class FeaturedCollection extends HTMLElement {
  connectedCallback() {
    const swiperEl = this.querySelector('.featured-collection-swiper');
    if (!swiperEl) return;

    const wrapper = swiperEl.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    const slides = wrapper.querySelectorAll('.swiper-slide');
    if (slides.length <= 1) return;

    const desktop = parseInt(this.dataset.columns, 10) || 4;
    const smallDesktop = parseInt(this.dataset.smallcolumns, 10) || desktop;
    const mobile = parseInt(this.dataset.mobColumns, 10) || 2;
    const spacing = parseInt(this.dataset.spacing, 10) || 20;

    const paginationEl = this.querySelector('.mobil_swiper-pagination');

    whenSwiperReady(() => {
      this.swiper = new Swiper(swiperEl, {
        slidesPerView: mobile,
        spaceBetween: spacing,
        speed: 600,
        loop: false,

        navigation: {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        },

        pagination: paginationEl
          ? {
              el: paginationEl,
              clickable: true,
              enabled: true,
            }
          : false,

        breakpoints: {
          320: {
            slidesPerView: mobile,
            spaceBetween: spacing,
            pagination: { enabled: true },
          },

          768: {
            slidesPerView: 2,
            spaceBetween: spacing,
            pagination: { enabled: true },
          },

          1024: {
            slidesPerView: 3,
            spaceBetween: spacing,
            pagination: { enabled: true },
          },

          1500: {
            slidesPerView: desktop,
            spaceBetween: spacing,
            pagination: { enabled: false },
          },
        },
      });
    });
  }
}

customElements.define('featured-collection', FeaturedCollection);


/* ======================================================================
   Product Recommendations Component 
   ====================================================================== */


class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    this.productId = this.dataset.productId;
    this.sectionId = this.dataset.sectionId;
    this.recommendedURL = this.dataset.url;

    this.spacing = Number(this.dataset.spacing) || 20;
    this.columns = Number(this.dataset.columns) || 4;
    this.mobColumns = Number(this.dataset.mobColumns) || 1;
    this.type = this.dataset.type || 'default';

    this.handleObserver = this.handleObserver.bind(this);

    this.observer = new IntersectionObserver(this.handleObserver, {
      rootMargin: "0px 0px 400px 0px",
    });
  }

  connectedCallback() {
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer.disconnect();
  }

  handleObserver(entries) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      this.observer.disconnect();
      this.loadRecommendedProducts(
        this.recommendedURL,
        this.productId,
        this.sectionId
      );
    });
  }

  loadRecommendedProducts(recommendedURL, productId, sectionId) {
    fetch(`${recommendedURL}&product_id=${productId}&section_id=${sectionId}`)
      .then((res) => res.text())
      .then((data) => {
        const html = document.createElement("div");
        html.innerHTML = data;

        const recommendations = html.querySelector("product-recommendations");
        if (!recommendations || !recommendations.innerHTML.trim()) return;

        this.innerHTML = recommendations.innerHTML;

        //  FIX: support both default & complementary inner containers
        this.productsInner =
          this.querySelector(".product_recommendations_inner") ||
          this.querySelector(".complementary_products_inner");

        if (!this.productsInner) return;

        requestAnimationFrame(() => {
          this.initRecommendedSlider(
            this.productsInner,
            this.spacing,
            this.columns,
            this.mobColumns
          );
        });

        document.dispatchEvent(
          new CustomEvent("recommended-products-updated")
        );
      });
  }

  getSwiperBreakpoints(spacing, columns, mobColumns) {
    // COMPLEMENTARY PRODUCTS
    if (this.type === "complementary-products") {
      return {
        0: {
          slidesPerView: 2.2,
          spaceBetween: 15,
        },
        480: {
          slidesPerView: 2.2,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
        1024: {
          slidesPerView: 2.1,
          spaceBetween: 15,
        },
        1400: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
      };
    }

    // DEFAULT PRODUCT RECOMMENDATIONS
    return {
      0: {
        slidesPerView: mobColumns,
        spaceBetween: 15,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: spacing,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: spacing,
      },
      1280: {
        slidesPerView: 4,
        spaceBetween: spacing,
      },
      1400: {
        slidesPerView: columns,
        spaceBetween: spacing,
      },
    };
  }

  initRecommendedSlider(inner, spacing, columns, mobColumns) {
  const prevBtn = this.querySelector(".pr_prev");
  const nextBtn = this.querySelector(".pr_next");

  //  pagination selectors
  const defaultPagination = this.querySelector(".rec-swiper-pagination");
  const complementaryPagination = this.querySelector(
    ".complementary-products_swiper-pagination"
  );

  if (inner.swiper) inner.swiper.destroy(true, true);

  const initSwiper = () => {
    new Swiper(inner, {
      slidesPerView: columns,
      spaceBetween: spacing,
      speed: 600,
      grabCursor: this.type === "complementary-products",
      watchOverflow: true,
      observer: true,
      observeParents: true,

      navigation:
        prevBtn && nextBtn && this.type !== "complementary-products"
          ? {
              nextEl: nextBtn,
              prevEl: prevBtn,
            }
          : false,

      //  pagination logic per slider type
      pagination:
        this.type === "complementary-products" && complementaryPagination
          ? {
              el: complementaryPagination,
              clickable: true,
            }
          : defaultPagination
          ? {
              el: defaultPagination,
              clickable: true,
            }
          : false,

      breakpoints: this.getSwiperBreakpoints(
        spacing,
        columns,
        mobColumns
      ),
    });
  };

  // Safe Swiper init
  if (window.Swiper) {
    initSwiper();
  } else {
    document.addEventListener("swiper:loaded", initSwiper, { once: true });
  }
}
}

customElements.define("product-recommendations",  ProductRecommendations);





/* ======================================================================
   QuickAdd Component 
   ====================================================================== */


/* ======================== Quick view drawer open code ================== */
function openDrawer(drawerWrapper, triggerBtn) {
  if (!drawerWrapper) return;

  const drawerInner = drawerWrapper.querySelector('.quick_add-wrapper_inner');
  const closeBtn = drawerWrapper.querySelector('.quick_add_drawer_close');

  const focusableSelectors =
    'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';

  // Save trigger
  drawerWrapper._triggerBtn = triggerBtn;

  /* -----------------------------
     OPEN STATE
  ----------------------------- */
  drawerWrapper.removeAttribute('inert');
  drawerWrapper.setAttribute('aria-hidden', 'false');
  drawerWrapper.classList.add('is-open');
  

  //  Scroll lock
  document.documentElement.classList.add('lenis', 'lenis-stopped');
  document.body.setAttribute('data-scroll-locked', 'true');
  document.body.classList.add('quick-add-open');

  // Focus first focusable (AFTER async content)
  setTimeout(() => {
    const focusables = drawerWrapper.querySelectorAll(focusableSelectors);
    (focusables[0] || drawerInner).focus();
  }, 50);

  /* -----------------------------
     KEYBOARD: ESC + FOCUS TRAP
  ----------------------------- */
  function handleKeydown(e) {
    if (e.key === 'Escape') {
      closeDrawer(drawerWrapper);
      return;
    }

    if (e.key !== 'Tab') return;

    //  Recalculate every time (fixes async content issue)
    const focusables = drawerWrapper.querySelectorAll(focusableSelectors);
    if (!focusables.length) return;

    const first = focusables[0];
    const last = focusables[focusables.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  drawerWrapper.addEventListener('keydown', handleKeydown);
  drawerWrapper._handleKeydown = handleKeydown;

  /* -----------------------------
     OUTSIDE CLICK (INNER PANEL)
  ----------------------------- */
  function handleOutsideClick(e) {
    if (!drawerInner.contains(e.target) && e.target !== triggerBtn) {
      closeDrawer(drawerWrapper);
    }
  }

  setTimeout(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    document.addEventListener('touchstart', handleOutsideClick);
  }, 0);

  drawerWrapper._handleOutsideClick = handleOutsideClick;

  /* -----------------------------
     CLOSE BUTTON
  ----------------------------- */
  if (closeBtn) {
    closeBtn.addEventListener('click', () => closeDrawer(drawerWrapper));
  }
}

function closeDrawer(drawerWrapper) {
  if (!drawerWrapper) return;

  drawerWrapper.setAttribute('inert', '');
  drawerWrapper.setAttribute('aria-hidden', 'true');
  drawerWrapper.classList.remove('is-open');
  

  //  Unlock scroll
  document.documentElement.classList.remove('lenis', 'lenis-stopped');
  document.body.removeAttribute('data-scroll-locked');
  document.body.classList.remove('quick-add-open');

  // Cleanup listeners
  if (drawerWrapper._handleKeydown) {
    drawerWrapper.removeEventListener('keydown', drawerWrapper._handleKeydown);
  }

  if (drawerWrapper._handleOutsideClick) {
    document.removeEventListener('mousedown', drawerWrapper._handleOutsideClick);
    document.removeEventListener('touchstart', drawerWrapper._handleOutsideClick);
  }

  // Restore focus
  if (drawerWrapper._triggerBtn) {
    drawerWrapper._triggerBtn.focus();
  }
}



// ========== QUICK ADD CODE ============= //

class QuickAdd extends HTMLElement {
  constructor() {
    super();
    this.productUrl = this.dataset.productUrl;
    this.btn = this.querySelector('button');
    this.drawerWrapper = document.querySelector('.quick_add_slide')
    this.drawer = document.querySelector('.quick_add_side_inner');
    this.handleProductFetch = this.handleProductFetch.bind(this);
  }

  connectedCallback() {
    this.attachEventHandler();   
    
  }

  attachEventHandler() {
    if(this._isEventAttached) return;
    if(!this.btn) return;

    this._isEventAttached = true;
    this.btn.addEventListener('click', this.handleProductFetch)
  }

  showSkeleton() {
  this.drawer.innerHTML = `<div class="quick_add_block">Quick View </div>
  `;
}

  handleProductFetch() {
  this.showSkeleton();

  fetch(`${this.productUrl}`)
    .then((res) => res.text())
    .then((htmlString) => {
      const div = document.createElement('div');
      div.innerHTML = htmlString;

      const newHTML = div.querySelector('.main_product_main');
      if (!newHTML) return;

      const mainProduct = newHTML.querySelector('main-product-section');

      const originalSectionId = mainProduct.dataset.sectionId;
      const quickAddSectionId = `quick-add-${originalSectionId}`;

      // Replace IDs
      newHTML.innerHTML = newHTML.innerHTML.replaceAll(
        originalSectionId,
        quickAddSectionId
      );

      newHTML.querySelector('main-product-section').dataset.originalSectionId = originalSectionId;
      newHTML.querySelector('main-product-section').dataset.updateUrl = 'false';    
      
      const tabs = newHTML.querySelectorAll('.main_product_collapsible_wrapper');
      if(tabs) {
        tabs.forEach((tab) => {
          tab.remove();
        })
      }

      const pickup = newHTML.querySelector('.main_product_pickup_availability_wrapper');
      if(pickup) {
        pickup.remove();
      }

      const badges_block = newHTML.querySelector('.main_product_badges_block');
      if(badges_block) {
        badges_block.remove();
      }  
      
       const size_block = newHTML.querySelector('.main_product_size_chart');
      if(size_block) {
        size_block.remove();
      } 

      // Inject
      this.drawer.replaceChildren(...newHTML.children);
    });

    openDrawer(this.drawerWrapper, this.btn)
}

}

customElements.define('quick-add-to-cart', QuickAdd);




/* =============== Quick view call back function ================== */

document.addEventListener('collection-grid-update', () => {
  document.querySelectorAll('quick-add-to-cart').forEach((el) => {
    el.attachEventHandler();
  });
});




/* ======================================================================
   GIFT CARD 'recipient-form' Component JS
   ====================================================================== */

if (!customElements.get('recipient-form')) {
  class RecipientForm extends HTMLElement {
    constructor() {
      super();

      this.sectionId = this.dataset.sectionId;

      this.checkbox = this.qs(`Recipient_checkbox`);
      this.hiddenControls = this.qs(`Recipient_control`);
      this.wrapper = this.querySelector('.recipients_input_wrapper');
      this.inner = this.wrapper?.querySelector('.recipients_input_inner');

      this.emailInput = this.qs(`Recipient_email`);
      this.nameInput = this.qs(`Recipient_name`);
      this.messageInput = this.qs(`Recipient_message`);
      this.sendonInput = this.qs(`Recipient_send_on`);
      this.offsetProperty = this.qs(`Recipient_timezone_offset`);

      if (this.checkbox) this.checkbox.disabled = false;
      if (this.hiddenControls) this.hiddenControls.disabled = true;

      if (this.offsetProperty) {
        this.offsetProperty.value = new Date().getTimezoneOffset().toString();
      }

      this.addEventListener('change', () => this.toggleWrapper());
    }

    qs(prefix) {
      return this.querySelector(`#${prefix}--${this.sectionId}`);
    }

    connectedCallback() {
      if (!this.inner || !this.wrapper) return;

      const height = this.inner.clientHeight;
      this.wrapper.style.setProperty('--height', `${height}px`);
    }

    toggleWrapper() {
      if (!this.checkbox || !this.wrapper) return;

      this.wrapper.toggleAttribute('open', this.checkbox.checked);
    }
  }

  customElements.define('recipient-form', RecipientForm);
}


/* ======================================================================
   MAIN PRODUCT PAGE Component 
   ====================================================================== */


//  ================= VARIANT PICKER =================
class VariantPicker extends HTMLElement {
  constructor() {
    super();    
  }

  connectedCallback() {
    this.addEventListener('change', (e) => {
      this.selectedOptions = this.getSelectedOptions;
      
      this.dispatchEvent(
        new CustomEvent('variant-change', {
          detail: {
            selectedOptions: this.selectedOptions
          },
          bubbles: true
        })
      )
    })
  }

  get getSelectedOptions() {
      const selectValues = Array.from(this.querySelectorAll('select')).map((select) => {
        return select.selectedOptions[0].dataset.value;
      })

      const radioValues = Array.from(this.querySelectorAll('input[type="radio"]:checked')).map((input) => {
        return input.dataset.value;
      })

      return [...selectValues, ...radioValues];
  }
}

customElements.define('variant-picker', VariantPicker);





//  ================= PRODUCT PICKUP DROP-DOWN  =================
document.addEventListener('click', function (e) {
  const toggleBtn = e.target.closest('.accordion_open_btn_pickup');
  if (!toggleBtn) return;

  const wrapper = toggleBtn.closest('.main_product_pickup_availability_wrapper');
  const drawer = wrapper?.querySelector('.pickup_availability_drawer');

  if (!wrapper || !drawer) return;

  const isOpen = wrapper.classList.contains('is-open');

  wrapper.classList.toggle('is-open', !isOpen);
  drawer.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
  toggleBtn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
});


//  ================= QUANTITY PICKER =================
class QuantityPicker extends HTMLElement {
  constructor() {
    super();

    this.minusBtn = this.querySelector('[data-minus]');
    this.plusBtn  = this.querySelector('[data-plus]');
    this.input    = this.querySelector('input[type="text"]');

    if (!this.input) return;

    this.step = Number(this.input.step) || 1;
    this.min  = Number(this.input.dataset.min) || 1;
    this.max  = this.input.dataset.max ? Number(this.input.dataset.max) : null;

    this.value = Number(this.input.value) || this.min;
  }

  connectedCallback() {
    if (!this.input || !this.minusBtn || !this.plusBtn) return;

    this.minusBtn.addEventListener('click', () => this.change(-this.step));
    this.plusBtn.addEventListener('click', () => this.change(this.step));

    this.input.addEventListener(
      'input',
      this.debounce(() => {
        this.setValue(Number(this.input.value) || this.min);
      }, 600)
    );

    this.updateButtons();
  }

  /* -------- Value Logic -------- */

  change(amount) {
    this.setValue(this.value + amount);
  }

  setValue(val) {
    this.value = Math.min(
      this.max ?? Infinity,
      Math.max(this.min, val)
    );

    this.input.value = this.value;
    this.updateButtons();

    this.dispatchEvent(
      new CustomEvent('quantity-change', {
        detail: { value: this.value },
        bubbles: true
      })
    );
  }

  updateButtons() {
    this.minusBtn.disabled = this.value <= this.min;
    this.plusBtn.disabled  = this.max !== null && this.value >= this.max;
  }

  /* -------- Utils -------- */

  debounce(fn, delay) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  }
}

customElements.define('quantity-picker', QuantityPicker);


// =================  PRODUCT MEDIA  ================= //
class ProductMedia extends HTMLElement {
  constructor() {
    super();
    this.videos = this.querySelectorAll('video');
    this.yFrames = this.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="youtu.be"]');
    this.vFrames = this.querySelectorAll('iframe[src*="vimeo.com"]');
    this.models = this.querySelectorAll('product-model');
  }

  connectedCallback() {
    if(this.videos.length) {
      this.videos.forEach((video) => {
        video.addEventListener('click', (e) => {
          e.preventDefault();
          this.handleVdoClick(video);
        })
      })
    }

    if(this.yFrames.length) {
      this.yFrames.forEach((yFrame) => {
        yFrame.nextElementSibling.addEventListener('click', () => {
          yFrame.nextElementSibling.style.pointerEvents = 'none';
          this.handleYframeClick(yFrame);
        })
      })
    }

    if(this.vFrames.length) {
      this.vFrames.forEach((vFrame) => {
        vFrame.nextElementSibling.addEventListener('click', () => {
          vFrame.nextElementSibling.style.pointerEvents = 'none';
          this.handleVframeClick(vFrame);
        })
      })
    }

    if(this.models.length) {
      this.models.forEach((model) => {
        model.addEventListener('mouseenter', () => {
          lenis.stop();
          document.documentElement.style.overflow = 'auto';
        })

        model.addEventListener('mouseleave', () => {
          lenis.start();
          document.documentElement.style.overflow = 'unset';
        })

        model.addEventListener('click', () => this.handleModelClick(model));
      })
    }
  }

  handleVdoClick(vdo) {
    this.pauseAllMedia(vdo);
    vdo.nextElementSibling.classList.add('hide');
    if(vdo.paused) {
      vdo.play();
      vdo.nextElementSibling.classList.add('hide'); 
    } else {
      vdo.pause();
      vdo.nextElementSibling.classList.remove('hide');
    }
  }

  handleYframeClick(yFrame) {
    this.pauseAllMedia(yFrame);
    yFrame.contentWindow.postMessage(
      JSON.stringify({ event: "command", func: "playVideo", args: [] }),
      "*"
    );
  }

  handleVframeClick(vFrame) {
    this.pauseAllMedia(vFrame);
    vFrame.contentWindow.postMessage(
      { method: "play" },
      "*"
    );
  }

  handleModelClick(model) {
    console.log('click')
    this.pauseAllMedia(model)
  }

  pauseAllMedia(except = null) {
    this.videos.forEach((vdo) => {
      if(vdo != except) {
        vdo.nextElementSibling.classList.remove('hide');
        vdo.pause();
      }
    })

    this.yFrames.forEach((yFrame) => {
      if (yFrame !== except) {
        yFrame.nextElementSibling.style.pointerEvents = 'all';
        yFrame.contentWindow.postMessage(
          JSON.stringify({ event: "command", func: "pauseVideo", args: [] }),
          "*"
        );
      }
    });

    this.vFrames.forEach((vFrame) => {
      if (vFrame !== except) {
        vFrame.nextElementSibling.style.pointerEvents = 'all';
        vFrame.contentWindow.postMessage({ method: "pause" }, "*");
      }
    });

    this.models.forEach((model) => {
      if(model !== except) {
        const modelViewer = model.querySelector('model-viewer');

        if(!modelViewer) return;
        if (model.modelViewerUI) model.modelViewerUI.pause();
      }
    })
  }
}

customElements.define('product-media', ProductMedia);

// ================= Mobile VIEW  ================= //
class ProductMobileMedia extends HTMLElement {
  constructor() {
    super();

    this.mobmainSlider  = this.querySelector('.product_slider_main_media');
    this.mobthumbSlider = this.querySelector('.product_slider_view_thumbnail_media');
    this.spacing        = this.dataset.spacing || 0;

    this.videos         = [...this.querySelectorAll('video')];
    this.youtubeFrames  = [...this.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="youtu.be"]')];
    this.vimeoFrames    = [...this.querySelectorAll('iframe[src*="vimeo.com"]')];
    this.models         = [...this.querySelectorAll('product-model')];
  }

  connectedCallback() {
    if (!this.mobmainSlider) return;

    this.initSwiper();
    this.initVideos();
    this.initYouTube();
    this.initVimeo();
    this.initModels();
  }

  /* ---------------- Swiper ---------------- */

  initSwiper() {
    
    if (this.mainSwiper) return; //  ADD

    whenSwiperReady(() => { //  ADD
      this.mainSwiper?.destroy(true, true);
      this.thumbSwiper?.destroy(true, true);

      if (this.mobthumbSlider) {
        this.thumbSwiper = new Swiper(this.mobthumbSlider, {
          direction: "horizontal",
          slidesPerView: 6,
          spaceBetween: 5,
          speed: 600,
          watchSlidesProgress: true,

          breakpoints: {
            1360: {
              direction: "horizontal",
              slidesPerView: 7
            }
          }
        });
      }

      this.mainSwiper = new Swiper(this.mobmainSlider, {
        slidesPerView: 1,
        spaceBetween: this.spacing,
        speed: 600,
        autoHeight: true,
        grabCursor: true,
        navigation: {
          prevEl: this.querySelector('.swiper-button-prev'),
          nextEl: this.querySelector('.swiper-button-next'),
        },
        thumbs: { swiper: this.thumbSwiper },
      });
    }); //  ADD
  }


  /* ---------------- Videos ---------------- */

  initVideos() {
    this.videos.forEach(video => {
      ['click', 'touchend'].forEach(evt => {
        video.addEventListener(evt, e => {
          e.preventDefault();
          this.toggleVideo(video);
        });
      });
    });
  }

  toggleVideo(video) {
    this.pauseAll(video);

    const overlay = video.nextElementSibling;
    if (!overlay) return;

    if (video.paused) {
      video.play();
      overlay.classList.add('hide');
    } else {
      video.pause();
      overlay.classList.remove('hide');
    }
  }

  /* ---------------- YouTube ---------------- */

  initYouTube() {
    this.youtubeFrames.forEach(frame => {
      const overlay = frame.nextElementSibling;
      if (!overlay) return;

      ['click', 'touchend'].forEach(evt => {
        overlay.addEventListener(evt, () => {
          overlay.style.pointerEvents = 'none';
          this.pauseAll(frame);
          this.postYouTube(frame, 'playVideo');
        });
      });
    });
  }

  postYouTube(frame, action) {
    frame.contentWindow?.postMessage(
      JSON.stringify({ event: 'command', func: action, args: [] }),
      '*'
    );
  }

  /* ---------------- Vimeo ---------------- */

  initVimeo() {
    this.vimeoFrames.forEach(frame => {
      const overlay = frame.nextElementSibling;
      if (!overlay) return;

      ['click', 'touchend'].forEach(evt => {
        overlay.addEventListener(evt, () => {
          overlay.style.pointerEvents = 'none';
          this.pauseAll(frame);
          frame.contentWindow?.postMessage({ method: 'play' }, '*');
        });
      });
    });
  }

  /* ---------------- Models ---------------- */

  initModels() {
    this.models.forEach(model => {
      model.addEventListener('mouseenter', () => this.lockScroll());
      model.addEventListener('mouseleave', () => this.unlockScroll());
      model.addEventListener('touchstart', () => this.lockScroll());
      model.addEventListener('touchend', () => {
        this.unlockScroll();
        this.pauseAll(model);
      });
    });
  }

  lockScroll() {
    lenis.stop();
    document.documentElement.style.overflow = 'auto';
    if (this.mainSwiper) this.mainSwiper.allowTouchMove = false;
  }

  unlockScroll() {
    lenis.start();
    document.documentElement.style.overflow = 'unset';
    if (this.mainSwiper) this.mainSwiper.allowTouchMove = true;
  }

  /* ---------------- Pause All ---------------- */

  pauseAll(except) {
    this.videos.forEach(v => {
      if (v !== except) {
        v.pause();
        v.nextElementSibling?.classList.remove('hide');
      }
    });

    this.youtubeFrames.forEach(f => {
      if (f !== except) {
        f.nextElementSibling && (f.nextElementSibling.style.pointerEvents = 'all');
        this.postYouTube(f, 'pauseVideo');
      }
    });

    this.vimeoFrames.forEach(f => {
      if (f !== except) {
        f.nextElementSibling && (f.nextElementSibling.style.pointerEvents = 'all');
        f.contentWindow?.postMessage({ method: 'pause' }, '*');
      }
    });

    this.models.forEach(model => {
      if (model !== except && model.modelViewerUI) {
        model.modelViewerUI.pause();
        model.querySelector('.shopify-model-viewer-ui__button')?.removeAttribute('hidden');
      }
    });
  }
}

customElements.define('product-slider-view-media', ProductMobileMedia);




//================= MAIN PRODUCT FUNCTION =================== //
class MainProduct extends HTMLElement {
  constructor() {
    super();
    this.originalSectionId = this.dataset.originalSectionId;
    this.sectionId = this.dataset.sectionId;
    this.productUrl = this.dataset.productUrl;
    this.isMainProduct = this.dataset.mainProduct;
    this.btn = this.querySelector('.product_form_buy_button');
    this.baseUrl = this.dataset.baseUrl;
    this.rootSection = this.closest('.product-section');
  }

  connectedCallback() {
    this.addEventListener('variant-change', this.onVariantChange.bind(this));
    this.addEventListener('quantity-change', this.onQuantityChange.bind(this));
  }

  onQuantityChange(e) {
    const value = e.detail.value;
    const baseInput = this.querySelector('input[name="quantity"]');
    if(baseInput) {
      baseInput.value = value;
    }    
  }

  onVariantChange(e) {
    const selectedOptions = e.detail.selectedOptions;
    
    this.requestURL = this.buildURL(selectedOptions);
    
    this.loadInfo(this.requestURL);
  }

  buildURL(options) {
    const params = [];
    if(options.length) {
      params.push(`option_values=${options.join(',')}`);
    }

    if(this.isMainProduct != 'true') {
      return `${this.productUrl}?section_id=${this.sectionId}&${params.join('&')}`;
    } else {
      return `${this.productUrl}?${params.join('&')}`;
    }    
  }

  loadInfo(url) {
    fetch(url)
    .then((res) => res.text())
    .then((htmlString) => {
      const html = new DOMParser().parseFromString(htmlString, 'text/html');
      this.updateContent(html);
    })
  }

  updateContent(html) {    
    const originalSectionId = this.dataset.originalSectionId;
    const container = html.querySelector('main-product-section');

    if(this.sectionId.includes('quick-add')) {
      const newSectionId = `quick-add-${originalSectionId}`;  
      console.log(newSectionId, originalSectionId);
      console.log(html);
      
      if(!container) return;

      container.innerHTML = container.innerHTML.replaceAll(originalSectionId, newSectionId);
    }

    container.dataset.sectionId = this.sectionId;

    // UPDATE PRICE
    const oldPrice = this.querySelector(`#Price-${this.sectionId}`);
    const newPrice = html.querySelector(`#Price-${this.sectionId}`);

    if(oldPrice && newPrice) {
      oldPrice.innerHTML = newPrice.innerHTML;
    }

    // UPDATE SKU
    const oldSKU = this.querySelector(`#SKU-${this.sectionId}`)
    const newSKU = html.querySelector(`#SKU-${this.sectionId}`)

    if(oldSKU && newSKU) {
      oldSKU.innerHTML = newSKU.innerHTML;
    }

    // UPDATE VARIANT PICKER
    const oldVariantPicker = this.querySelector(`#Variant_picker-${this.sectionId}`);
    const newVariantPicker = html.querySelector(`#Variant_picker-${this.sectionId}`);

    if(oldVariantPicker && newVariantPicker) {
      oldVariantPicker.innerHTML = newVariantPicker.innerHTML;
    }

    // UPDATE INVENTORY
    const oldInventory = this.querySelector(`#Inventory-${this.sectionId}`);
    const newInventory = html.querySelector(`#Inventory-${this.sectionId}`);

    if(oldInventory && newInventory) {
      oldInventory.innerHTML = newInventory.innerHTML;
    }

    // UPDATE QUANTITY
    const oldQuantity = this.querySelector(`#Quantity-${this.sectionId}`);
    const newQuantity = html.querySelector(`#Quantity-${this.sectionId}`);

    if(oldQuantity && newQuantity) {
      oldQuantity.innerHTML = newQuantity.innerHTML;
    }

    // UPDATE PICKUP AVAILABILITY
    const oldPickup = this.querySelector(`#Pickup-${this.sectionId}`);
    const newPickup = html.querySelector(`#Pickup-${this.sectionId}`);

    if(newPickup && oldPickup) {
      oldPickup.innerHTML = newPickup.innerHTML;
    }

    // UPDATE ADD TO CART BUTTON
    const oldBtn = this.querySelector('product-form');
    const newBtn = html.querySelector('product-form');

    if(oldBtn && newBtn) {
      oldBtn.innerHTML = newBtn.innerHTML;
    }

    // UPDATE FEATURED MEDIA
    // const oldFeaturedMedia = this.querySelector(`#FeaturedMedia-${this.sectionId}`);
    // const newFeaturedMedia = html.querySelector(`#FeaturedMedia-${this.sectionId}`);

    
    // if(oldFeaturedMedia && newFeaturedMedia) {
    //   oldFeaturedMedia.innerHTML = newFeaturedMedia.innerHTML;
    // }

    // // UPDATE MOBILE MEDIA
    // const oldMedia = this.querySelector('.product_slider_wrapper');
    // const newMedia = html.querySelector('.product_slider_wrapper');

    // if(oldMedia && newMedia) {
    //   oldMedia.innerHTML = newMedia.innerHTML;
    // }

    const variantData = this.extractVariantData(html);


    const backInStock =
        this.querySelector('[data-back-in-stock]');

      if (backInStock && variantData) {

        // Show / Hide

        if (variantData.available) {

          backInStock.style.display = 'none';

        } else {

          backInStock.style.display = '';
        }

        // Update variant id

        const variantInput =
          backInStock.querySelector(
            '[data-notification-variant]'
          );

        if (variantInput) {
          variantInput.value = variantData.id;
        }

        // Update product title

        const productInput =
          backInStock.querySelector(
            '[data-notification-product]'
          );

        if (productInput) {

          productInput.value =
            `${variantData.name}`;
        }
      }

    if (variantData && variantData.available) {

      // UPDATE FEATURED MEDIA
      const oldFeaturedMedia = this.querySelector(`#FeaturedMedia-${this.sectionId}`);
      const newFeaturedMedia = html.querySelector(`#FeaturedMedia-${this.sectionId}`);

      if(oldFeaturedMedia && newFeaturedMedia) {
        oldFeaturedMedia.innerHTML = newFeaturedMedia.innerHTML;
      }

      // UPDATE MOBILE MEDIA
      const oldMedia = this.querySelector('.product_slider_wrapper');
      const newMedia = html.querySelector('.product_slider_wrapper');

      if(oldMedia && newMedia) {
        oldMedia.innerHTML = newMedia.innerHTML;
      }

    } else {
      //  Variant invalid or unavailable
      console.log('Media not updated - invalid/unavailable variant');
    }

    if(this.dataset.updateUrl === 'true') {
      this.updateURL(html);
    }    

    this.setMainInput(html);


    const addToCartBtn =
        this.querySelector('.product_form_buy_button');

      if (addToCartBtn) {
        addToCartBtn.style.display =
          variantData.available ? '' : 'none';
      }
  }
  
  extractVariantData(html) {
    const data = this.querySelector('[data-selected-variant]').innerHTML;
    if(!data) return;

    return JSON.parse(data);
  }

  updateURL(html) {
    const variantData = this.extractVariantData(html);
    if(!variantData) return;

    window.history.replaceState(null, {}, `${this.productUrl}?variant=${variantData.id}`);

    this.handlePickup(variantData.id);
  }

  handlePickup(id) {
    let baseUrl = this.dataset.baseUrl;
    if(!baseUrl.endsWith('/')) {
      baseUrl = baseUrl + '/';
    }

    fetch(`${baseUrl}variants/${id}/?section_id=pickup-availability-section`)
    .then((res) => res.text())
    .then((data) => {
      const container = document.querySelector('[data-store-availability-container]');
      const newHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('.pickup_availability_wrapper');

      if(container && newHTML) {
        container.innerHTML = newHTML.innerHTML;
        initPickupAccordion(container);
        const pickUpDrawer = container.querySelector('pickup-availability-drawer');
        const pickUpBtn = container.querySelector('.accordion_open_btn_pickup');
        // Pickup CODE =============
        if(pickUpDrawer && pickUpBtn) {
          // pickUpBtn.addEventListener('click', () => {
          //   openDrawer(pickUpDrawer, pickUpBtn, this.rootSection);
          // })          
            if (!toggleBtn) return;

              const wrapper = toggleBtn.closest('.main_product_pickup_availability_wrapper');
              const drawer = wrapper?.querySelector('.pickup_availability_drawer');

              if (!wrapper || !drawer) return;

              const isOpen = wrapper.classList.contains('is-open');

              wrapper.classList.toggle('is-open', !isOpen);
              drawer.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
              toggleBtn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          
        }

        if(pickUpDrawer) {
          if (!toggleBtn) return;

              const wrapper = toggleBtn.closest('.main_product_pickup_availability_wrapper');
              const drawer = wrapper?.querySelector('.pickup_availability_drawer');

              if (!wrapper || !drawer) return;

              const isOpen = wrapper.classList.contains('is-open');

              wrapper.classList.toggle('is-open', !isOpen);
              drawer.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
              toggleBtn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        }
      }
    })

  }
  

  setMainInput(html) {
    const variantData = this.extractVariantData(html);
    if(!variantData) return;

    this.querySelector('input[name="id"]').value = variantData.id;
  }
}

customElements.define('main-product-section', MainProduct);


// ================= PRODUCT FORM  ================= //

class ProductatcForm extends HTMLElement {
  constructor() {
    super();
    this.submit = this.submit.bind(this);
    this.refresh = this.cache.bind(this);
  }

    connectedCallback() {
    this.cache();
    this.addEventListener("submit", this.submit);
    this.addEventListener("variant-change", this.refresh);
    // Fix: stop the native form submit so Shopify only sends one AddToCart
    this.addEventListener("click", (e) => {
      const btn = e.target.closest(".product_form_buy_button");
      if (!btn || !this.contains(btn)) return;
      e.preventDefault();
      const form = btn.closest("form") || this.querySelector("form");
      if (!form) return;
      this.submit({ target: form, preventDefault() {}, stopPropagation() {} });
    }, true);
  }

  disconnectedCallback() {
    this.removeEventListener("submit", this.submit);
    this.removeEventListener("variant-change", this.refresh);
  }
  cache() {
    this.form = this.querySelector('form');
    this.btn = this.querySelector('.product_form_buy_button');
    this.text = this.btn?.querySelector('.atc_status');
    this.load = this.btn?.querySelector('.loader');
    this.cart = document.querySelector('cart-contents');
    this.open = false;


    // ==========================
    // Gift Wrap Elements
    // ==========================
    this.giftWrap = document.querySelector('#product_gift_wrapp');

    // Main variant input
    // this.mainInput = this.querySelector('input[name="id"]');
    this.mainInput = this.querySelector('input[name="id"]') || document.querySelector('input[name="id"]');

   // console.log('giftWrap:', this.giftWrap);
    // console.log('mainInput:', this.mainInput);
  }

  async submit(e) {
    if (!e.target.closest('form')) return;

    e.preventDefault();
    e.stopPropagation(); // ← from reference, safe to add

    this.cache();
    if (!this.form || !this.btn) return;

    this.text.style.visibility = 'hidden';
    this.load.classList.remove('hidden');

    const formData = new FormData(this.form);

    try {
    //    const res = await fetch(`${Shopify.routes.root}cart/add.js`, {
    //     method: 'POST',
    //      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    //     body: formData
    //  });

      // ========================================
      // Build Main Product Payload
      // ========================================
      const payload = {};

      for (const [key, value] of formData.entries()) {
        const propertyMatch = key.match(/^properties\[(.+)\]$/);

        if (propertyMatch) {
          if (!payload.properties) payload.properties = {};
          payload.properties[propertyMatch[1]] = value;
        } else {
          payload[key] = value;
        }
      }

      // Main product item
      const items = [payload];

      // ========================================
      // Gift Wrap Product
      // Add gift wrap as a separate cart item
      // when checkbox is checked
      // ========================================
      if (this.giftWrap && this.giftWrap.checked) {
        items.push({
          id: this.giftWrap.value, // keep as string like reference
          quantity: 1,
          parent_id: this.mainInput?.value,
          properties: {
            for: `${this.mainInput?.dataset.title || ''}`
          }
        });
      }


      console.log('Cart items payload:', items);

      const res = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items })
      });

      const data = await res.json();

      const refresh = async () => {
        const sections = await fetch(
          `${Shopify.routes.root}?sections=cart-drawer,cart,cart-bubble`
        ).then(r => r.json());

        document.dispatchEvent(
          new CustomEvent('cart-update', {
            detail: { sections },
            bubbles: true
          })
        );
      };


      if (!res.ok) {
        await refresh();
        throw data;
      }

      // if (this.cart) {
      //   await refresh();
      //   this.open = true;
      // } else {
      //   window.location.href = `${Shopify.routes.root}cart`;
      // }

      // =============== UPDATE CART FEATURE (update cart notification message) ==================//
      if (this.cart) {
          await refresh();

          // Check if popup mode enabled
          const popupBtn = document.querySelector('.cart_sidebar_open_btn-popup');

          if (popupBtn) {
            // Popup notification mode
            this.open = false;

            // Get current cart count
            let cartCount = 0;

            try {
              const res = await fetch(`${Shopify.routes.root}cart.js`);
              const cartData = await res.json();
              cartCount = cartData.item_count || 0;
            } catch (e) {
              console.error('Cart fetch error:', e);
            }

            const popup = document.querySelector('.cart-toast-popup');

            if (popup) {
              clearTimeout(popup.hideTimer);

              const countText = popup.querySelector('.cart-toast-text small');

              if (countText) {
                const template =
                  popup.dataset.message || '[count] [item] in cart';

                countText.textContent = template
                  .replace('[count]', cartCount)
                  .replace('[item]', cartCount === 1 ? 'item' : 'items');
              }

              popup.classList.remove('show');

              requestAnimationFrame(() => {
                popup.classList.add('show');
              });

              popup.hideTimer = setTimeout(() => {
                popup.classList.remove('show');
              }, 5000);
            }

          } else {
            // Normal cart drawer mode
            this.open = true;
          }

        } else {
          window.location.href = `${Shopify.routes.root}cart`;
        }

    } catch (err) {
      this.showError(err);
    } finally {
      this.text.style.visibility = 'visible';
      this.load.classList.add('hidden');

      // --- drawer behavior ---
      if (this.open && this.cart) {
        const openBtn = document.querySelector('.cart_sidebar_open_btn');
        if (openBtn) {
          openBtn.dispatchEvent(
            new MouseEvent('click', { bubbles: true, cancelable: true })
          );
        }
      }
    }
  }

   showError(data) {
    const error = this.querySelector('.product_add_error');
    if (!error) return;

    let message = 'Unable to add product to cart';

    if (data?.errors && typeof data.errors === 'object') {
      const formattedErrors = [];

      Object.entries(data.errors).forEach(([field, value]) => {
        // Human-friendly field names with fallback
        let fieldLabel = field === 'email' ? 'Email' : field;

        // Normalize message
        if (value === "can't be blank") {
          formattedErrors.push(`${fieldLabel} can't be blank`);
        } 
        else if (value === 'is invalid') {
          formattedErrors.push(`${fieldLabel} is invalid`);
        } 
        else if (fieldLabel === 'send_on'){
          formattedErrors.push(`Send on must be within 90 days from now`);
        }
        else {
          formattedErrors.push(`${fieldLabel} ${value}`);
        }
      
      });

        message = formattedErrors.join('<br>');
      }
      else if (typeof data?.errors === 'string') {
        message = data.errors;
      }
      else if (typeof data?.description === 'string') {
        message = data.description;
      }
      else if (typeof data?.message === 'string') {
        message = data.message;
      }

      error.innerHTML = message;
      error.classList.remove('hidden');
   }
  
}



customElements.define('product-form', ProductatcForm);


// ================== Size chart ========== //

document.addEventListener('DOMContentLoaded', () => {
  const popup = document.querySelector('.size_chart_popup_main');
  const closeBtn = document.querySelector('.size_chart_popup_close');

  // Open popup
  document.addEventListener('click', (e) => {
    if (e.target.closest('.size_chart_main')) {
      popup.classList.add('active');
      document.body.classList.add('size-chart-active');

      if (typeof lenis !== 'undefined') {
        lenis.stop();
      }
    }
  });

  // Close on outside click
  if (popup) {
    popup.addEventListener('click', (e) => {
      if (!e.target.closest('.size_chart_popup_inner')) {
        closePopup();
      }
    });
  }

  // Close button
  if (closeBtn) {
    closeBtn.addEventListener('click', closePopup);
  }

  function closePopup() {
    popup.classList.remove('active');
    document.body.classList.remove('size-chart-active');

    if (typeof lenis !== 'undefined') {
      lenis.start();
    }
  }
});
/* ======================================================================
   MAIN PRODUCT PAGE Component end
   ====================================================================== */

/* ======================================================================
   Cart page and cart drawer PAGE Component 
   ====================================================================== */

  //  ================= Side cart drawer open and close ===================

document.addEventListener("DOMContentLoaded", function () {
  const openBtn = document.querySelector(".cart_sidebar_open_btn");
  const closeBtn = document.querySelector(".drawer_close_btn-cart");
  const cartSidebar = document.querySelector(".cart_sidebar_wrapper");
  if (!cartSidebar) return;
  const html = document.documentElement;
  const body = document.body;

  const focusableSelectors = `
    a[href],
    button:not([disabled]),
    textarea,
    input:not([disabled]),
    select,
    [tabindex]:not([tabindex="-1"])
  `;

  let firstFocusableEl = null;
  let lastFocusableEl = null;

  function setFocusableElements() {
    const focusables = cartSidebar.querySelectorAll(focusableSelectors);
    firstFocusableEl = focusables[0];
    lastFocusableEl = focusables[focusables.length - 1];
  }

  function openCart(e) {
    if (e) e.preventDefault();

    lastFocusedElement = document.activeElement;

    body.classList.add("cart-sidebar-open");
    html.classList.add("lenis-stopped");

    cartSidebar.classList.add("cart-sidebar-active");
    cartSidebar.removeAttribute("inert");
    cartSidebar.setAttribute("aria-hidden", "false");

    setFocusableElements();
    firstFocusableEl?.focus();
  }

  function closeCart(e) {
    if (e) e.preventDefault();

    body.classList.remove("cart-sidebar-open");
    html.classList.remove("lenis-stopped");

    cartSidebar.classList.remove("cart-sidebar-active");
    cartSidebar.setAttribute("inert", "");
    cartSidebar.setAttribute("aria-hidden", "true");

    if (lastFocusedElement) {
      lastFocusedElement.focus();
    }
  }

  /* ==========================
     Focus Trap (TAB Handling)
     ========================== */
  document.addEventListener("keydown", function (e) {
    if (!cartSidebar.classList.contains("cart-sidebar-active")) return;

    if (e.key === "Escape") {
      closeCart();
      return;
    }

    if (e.key !== "Tab") return;

    if (e.shiftKey) {
      // Shift + Tab
      if (document.activeElement === firstFocusableEl) {
        e.preventDefault();
        lastFocusableEl.focus();
      }
    } else {
      // Tab
      if (document.activeElement === lastFocusableEl) {
        e.preventDefault();
        firstFocusableEl.focus();
      }
    }
  });

  /* ==========================
     Click Outside to Close
     ========================== */
  cartSidebar.addEventListener("click", function (e) {
    if (e.target === cartSidebar) {
      closeCart();
    }
  });

  openBtn?.addEventListener("click", openCart);
  closeBtn?.addEventListener("click", closeCart);
});



//  ================= Side cart drawer (CART QUANTITY PICKER) =================== //
class ItemQuantity extends HTMLElement {
  constructor() {
    super();
    this.minusBtn = this.querySelector('[data-minus]');
    this.input = this.querySelector('input[type="text"]');
    this.plusBtn = this.querySelector('[data-plus]');
    this.value = Number(this.input.value); 
    this.step = Number(this.input.getAttribute('step'));
    this.min = this.input.dataset.min;
    this.max = this.input.dataset.max;
    this.line = this.dataset.line;
  }

  connectedCallback() {
    this.minusBtn.addEventListener('click', this.handleChange.bind(this));
    this.plusBtn.addEventListener('click', this.handleChange.bind(this));
    const debouncedInputandler = this._debounce((e) => this.handleInput(e), 1000)
    this.input.addEventListener('input', debouncedInputandler);
  }

  handleChange(e) {
    if(e.currentTarget.hasAttribute('data-plus')) {
      this.value = this.value + this.step;
      this.input.value = this.value;
    } else {
      this.value = this.value - this.step;
      this.input.value = this.value;
    }

    if(this.min) {
      if(this.value <= this.min) {
        this.minusBtn.setAttribute('disabled', '');
      } else {
        this.minusBtn.removeAttribute('disabled');
      }
    }
    
    if(this.max) {
      if(this.value >= this.max) {
        this.plusBtn.setAttribute('disabled', '');
      } else {
        this.plusBtn.removeAttribute('disabled');
      }
    }

    document.dispatchEvent(
      new CustomEvent('cart-quantity-change', {
        detail: {
          value: this.value,
          line: this.line
        },
        bubbles: true,
        composed: true
      })
    )    
  }

  handleInput(e) {
    this.value = Number(this.input.value);
    if(this.value == 0) {
      this.value = 1;
      this.input.value = 1;
    }

    if(this.min) {
      if(this.value <= this.min) {
        this.minusBtn.setAttribute('disabled', '');
      } else {
        this.minusBtn.removeAttribute('disabled');
      }
    }

    if(this.max) {
      if(this.value >= this.max) {
        this.plusBtn.setAttribute('disabled', '');
      } else {
        this.plusBtn.removeAttribute('disabled');
      }
    }

    this.dispatchEvent(
      new CustomEvent('cart-quantity-change', {
        detail: {
          value: this.value,
          line: this.line
        },
        bubbles: true,
        composed: true
      })
    ) 

  }

  _debounce(fn, wait = 1000) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('item-quantity', ItemQuantity);


//  ================= Side cart drawer (CART REMOVE) =================== //
class ItemRemove extends HTMLElement {
  constructor() {
    super();
    this.line = this.dataset.line;
    this.anchor = this.querySelector('a.item_remove_btn');
  }

  connectedCallback() {
    this.anchor.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(e) {
    e.preventDefault();

    document.dispatchEvent(
      new CustomEvent('cart-item-remove', {
        detail: {
          value: 0,
          line: this.line
        },
        bubbles: true,
        composed: true
      })
    )
  }
}

customElements.define('item-remove', ItemRemove);



// ========== CART NOTE ==========
class CartNote extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.textarea = this.querySelector('textarea');
    this.debounceTimer = null;
  }

  connectedCallback() {
    if (this.textarea && this.textarea.value.trim() !== '') {
      this.details.setAttribute('open', '');
    }

    this.textarea.addEventListener('input', () => {
      this.details.setAttribute('open', '');

      clearTimeout(this.debounceTimer);

      this.debounceTimer = setTimeout(() => {
        this.updateCartNote(this.textarea.value.trim());
      }, 500); 
    });
  }

  updateCartNote(value) {
    fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        note: value
      })
    })
    .then(res => res.json())
    .then(() => {
      console.log('Cart note updated');
    })
    .catch(err => {
      console.error('Cart note update failed', err);
    });
  }
}

customElements.define('cart-note', CartNote);

// ========== CART DISCOUNT ==========
class CartDiscount extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[name="discount"]');
    this.value = this.input.value;    
    this.btn = this.querySelector('button[name="cart_discount_btn"]');    
    this.remove = this.querySelector('[data-cart-discount-remove]');
    this.error = this.querySelector('.cart_discount_error');
  }

  connectedCallback() {
    this.input.addEventListener('input', this.handleInput.bind(this));
    this.btn.addEventListener('click', this.handleClick.bind(this));
    if(!this.remove) return;
    this.remove.addEventListener('click', this.handleRemove.bind(this));
  }

  handleInput() {
    if(this.error) {
      this.error.classList.add('hidden');
    }
    this.value = this.input.value.trim();
  }

  handleClick(e) {
    e.preventDefault();

    if(!this.value) {
      if(this.error) {
        this.error.classList.remove('hidden');
        this.input.focus();
        return;
      }
    }

    document.dispatchEvent(
      new CustomEvent('discount-btn-click', {
        detail: {
          discount: this.value,          
        },
        bubbles: true, 
        composed: true
      })
    )
  }

  handleRemove(e) {
    e.preventDefault();

    document.dispatchEvent(
      new CustomEvent('discount-remove-click', {
        detail: {
          discount: ''
        },
        bubbles: true,
        composed: true
      })
    )
  }
}

customElements.define('cart-discount-code', CartDiscount);


//  ================= Side cart drawer (MAIN CART CODE) =================== //

class CartContents extends HTMLElement {
  constructor() {
    super();
    this.onQtyChange = this.onQtyChange.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleDiscountRemove = this.handleDiscountRemove.bind(this);
    this.inner = this.querySelector('.cart_sidebar_inner') || this.querySelector('.cart_main_content');    
  }

  connectedCallback() {    
    document.addEventListener('cart-quantity-change', this.onQtyChange);
    document.addEventListener('cart-item-remove', this.handleRemove);
    document.addEventListener('discount-btn-click', this.handleClick);
    document.addEventListener('discount-remove-click', this.handleDiscountRemove);
    document.addEventListener('cart-update', updateCart); 
  }

  disconnectedCallback() {
    document.removeEventListener('cart-quantity-change', this.onQtyChange);
    document.removeEventListener('cart-item-remove', this.handleRemove);
    document.removeEventListener('discount-btn-click', this.handleClick);
    document.removeEventListener('discount-remove-click', this.handleDiscountRemove);
  }

  onQtyChange(e) {
    if(this.inner) {
      this.inner.classList.add('loading');
    }

    const { value, line } = e.detail;    

    const formData = {
      'line': line,
      'quantity': value,
      'sections': 'cart-drawer,cart,cart-bubble'
    }

    fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(async (res) => {
      const data = await res.json();

      if(!res.ok) {
        const sections = await fetch(`${window.Shopify.routes.root}?sections=cart-drawer,cart,cart-bubble`).then((res) => res.json());
        const rawData = {
          'line': line,
          'message': data.message || data.description,
          'sections': sections
        }

        document.dispatchEvent(
          new CustomEvent('cart-update', {
            detail: rawData,
            bubbles: true
          })
        )       

        throw new Error(data.description || data.message || 'Request failed');
      }
      return data;
    })
    .then((rawData) => {
      document.dispatchEvent(
        new CustomEvent('cart-update', {
          detail: rawData,
          bubbles: true
        })
      )
    })
    .catch((err) => {
      console.error('Error: ', err);
    })
    .finally(() => {
      this.inner.classList.remove('loading')
    })
  }

  handleRemove(e) {
    if(this.inner) {
      this.inner.classList.add('loading');
    }

    const { value, line } = e.detail;

    const formData = {
      'line': line,
      'quantity': value,
      'sections': 'cart-drawer,cart,cart-bubble'
    }

    fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then((res) => res.json())
    .then((data) => {
      document.dispatchEvent(
        new CustomEvent('cart-update', {
          detail: data,
          bubbles: true
        })
      )
    })
    .catch((err) => {
      console.error('Error: ', err);
    })
    .finally(() => {
      this.inner.classList.remove('loading');
    })
  } 

  handleClick(e) {
    if(this.inner) {
      this.inner.classList.add('loading');
    }

    const discount = e.detail.discount;

    const formData = {
      'discount': discount,
      'sections': 'cart-drawer,cart,cart-bubble'
    }

    fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then((res) => res.json())
    .then((data) => {
      if(data.discount_codes[0].applicable == false) {
        const error = this.querySelector('.cart_discount_error');
        
        if(error) {
          error.classList.remove('hidden');
          this.input.value = "";
        }

        if(this.inner) {
          this.inner.classList.remove('loading');
        }
      } else {
        document.dispatchEvent(
          new CustomEvent('cart-update', {
            detail: data,
            bubbles: true
          })
        )
      }      
    })
    .catch((err) => {
      console.error('Error: ', err)
    })
    .finally(() => {
      this.inner.classList.remove('loading');
    })
  }

  handleDiscountRemove(e) {
    if(this.inner) {
      this.inner.classList.add('loading');
    }

    const discount = e.detail.discount;

    const formData = {
      'discount': discount,
      'sections': 'cart-drawer,cart,cart-bubble'
    }

    fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'        
      },
      body: JSON.stringify(formData)
    })
    .then((res) => res.json())
    .then((data) => {
      document.dispatchEvent(
        new CustomEvent('cart-update', {
          detail:data,
          bubble: true
        })
      )
    })
    .catch((err) => {
      console.error('Error: ', err);
    })
    .finally(() => {
      if(this.inner) {
        this.inner.classList.remove('loading');
      }
    })
  }
}

customElements.define('cart-contents', CartContents);

//  ================= Side cart drawer (CART COUNT UPDATE CODE) =================== //
function updateCart(e) {
  const data = e.detail;
  const updatedDrawer = data.sections['cart-drawer'];
  const updatedCartPage = data.sections['cart'];
  const updatedCartBubble = data.sections['cart-bubble'];
  const errorMsg = e.detail.message;
  const line = e.detail.line;
  const parser = new DOMParser();

  // ========== CART DRAWER UPDATE ==========
  if (updatedDrawer) {
    const parsed = parser.parseFromString(updatedDrawer, 'text/html');

    //  Target drawer specifically by its inner class
    const allCartContents = document.querySelectorAll('cart-contents');
    let drawerEl = null;

    allCartContents.forEach(el => {
      if (el.querySelector('.cart_sidebar_inner') || el.querySelector('.cart_sidebar_content_wrapper')) {
        drawerEl = el;
      }
    });

    if (drawerEl) {
      const selectors = [
        '.cart_sidebar_header h4',
        '.cart_sidebar_content_wrapper',
        '.cart_sidebar_items_footer'
      ];

      selectors.forEach(sel => {
        const oldEl = drawerEl.querySelector(sel);
        const newEl = parsed.querySelector(sel);
        if (oldEl && newEl) oldEl.innerHTML = newEl.innerHTML;
      });

      if (errorMsg && line) {
        const errorWrapper = drawerEl.querySelector(`.cart_error[data-line="${line}"]`);
        if (errorWrapper) {
          errorWrapper.innerHTML = `<p>${errorMsg}</p>`;
          errorWrapper.removeAttribute('hidden');
        }
      }
    }
  }

  // ========== MAIN CART PAGE UPDATE ==========
  if (updatedCartPage) {
    const parsed = parser.parseFromString(updatedCartPage, 'text/html');

    //  Target cart page specifically by its inner class
    const allCartContents = document.querySelectorAll('cart-contents');
    let cartPageEl = null;

    allCartContents.forEach(el => {
      if (el.querySelector('.cart_main_content') || el.querySelector('.cart_main_header')) {
        cartPageEl = el;
      }
    });

    if (cartPageEl) {
      const selectors = [
        '.cart_main_header',
        '.cart_main_content'
      ];

      selectors.forEach(sel => {
        const oldEl = cartPageEl.querySelector(sel);
        const newEl = parsed.querySelector(sel);
        if (oldEl && newEl) oldEl.innerHTML = newEl.innerHTML;
      });

      //  Handle empty cart state
      const hasNewContent = parsed.querySelector('.cart_main_content');
      if (!hasNewContent) {
        // Cart is now empty — find your empty state element in new HTML
        // and replace the entire inner content
        const cartBody = parsed.querySelector('body');
        if (cartBody) {
          cartPageEl.innerHTML = cartBody.innerHTML;
        }
      }

      if (errorMsg && line) {
        const errorBox = cartPageEl.querySelector(`.cart_error[data-line="${line}"]`);
        if (errorBox) {
          errorBox.innerHTML = `<p>${errorMsg}</p>`;
          errorBox.hidden = false;
        }
      }
    }
  }

  // ========== CART BUBBLE UPDATE ==========
  if (updatedCartBubble) {
    const parsed = parser.parseFromString(updatedCartBubble, 'text/html');
    const oldBubble = document.querySelector('.cart-count-text');
    const newBubble = parsed.querySelector('.cart-count-text');
    if (oldBubble && newBubble) oldBubble.innerHTML = newBubble.innerHTML;
  }
}





  /* ======================================================================
   COLLECTION page Filter code Component 
====================================================================== */


// ==================== INFINITE SCROLL   ==================== //

class InfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector("button");
    this.sectionId = this.dataset.sectionId;

    this.isLoading = false;
  }

  connectedCallback() {
    if (!this.button) return;

    this.button.addEventListener("click", () => {
      this.loadProducts();
    });
  }

  loadProducts() {
    const nextUrl = this.button.dataset.nextUrl;
    if (!nextUrl) return;

    if (this.isLoading) return;

    this.isLoading = true;
    this.showLoader();
    this.disableFilters();

    const url = new URL(nextUrl, window.location.origin);
    url.searchParams.set("sections", this.sectionId);

    this.updatePage(url, this.sectionId);
  }

  updatePage(url, id) {
    const wasFilterOpen = this.closest(
      ".main_collection_filters_wrapper",
    )?.classList.contains("active");

    fetch(url.toString())
      .then((res) => res.json())
      .then((htmlString) => {
        const temp = document.createElement("div");
        temp.innerHTML = htmlString[id];

        const newWrapper = temp.querySelector(".main_collection_grid");
        const oldWrapper = document.querySelector(".main_collection_grid");

        if (oldWrapper && newWrapper) {
          const newItems = newWrapper.querySelectorAll(
            ".collection-grid_wrapper",
          );

          if (!newItems.length) {
            this.button.remove();
            return;
          }

          newItems.forEach((item) => {
            item.dataset.revealed = "false";
            oldWrapper.appendChild(item);
          });

          if (window.scrollReveal) {
            const revealItems = Array.from(newItems)
              .map((item) => item.querySelector(".reveal.stagger"))
              .filter(Boolean);

            scrollReveal.staggerBatch(revealItems);
          }

          if (wasFilterOpen) {
            const filterWrapper = document.querySelector(
              ".main_collection_filters_wrapper",
            );
            const gridWrapper = document.querySelector(
              ".main_collection_grid_wrapper",
            );

            if (filterWrapper && gridWrapper) {
              filterWrapper.classList.add("active");
              filterWrapper.removeAttribute("inert");
              gridWrapper.classList.add("padding");
            }
          }

          const newButton = temp.querySelector("infinite-scroll button");
          if (newButton && newButton?.dataset.nextUrl) {
            this.button.dataset.nextUrl = newButton.dataset.nextUrl;
          } else {
            this.button.remove();
          }
        }

        document.dispatchEvent(
          new CustomEvent("collection-grid-update", {
            detail: {
              url: url,
              sectionId: this.sectionId,
            },
          }),
        );
      })
      .catch((err) => {
        console.error("Error: ", err);
      })
      .finally(() => {
        this.enableFilters();
        this.hideLoader();
        this.isLoading = false;
      });
  }

  showLoader() {
    const text = this.button.querySelector(".load_more");
    const loader = this.button.querySelector(".pagination_loader");

    if (!text && !loader) return;

    text.classList.add("hidden");
    loader.classList.remove("hidden");
  }

  hideLoader() {
    const text = this.button.querySelector(".load_more");
    const loader = this.button.querySelector(".pagination_loader");

    if (!text && !loader) return;

    text.classList.remove("hidden");
    loader.classList.add("hidden");
  }

  disableFilters() {
    const filters = this.closest(".main_collection_filters_wrapper");
    if (!filters) return;

    filters.setAttribute("inert", "");
    filters.classList.add("is-loading");
  }

  enableFilters() {
    const filters = this.closest(".main_collection_filters_wrapper");
    if (!filters) return;

    filters.removeAttribute("inert");
    filters.classList.remove("is-loading");
  }
}

customElements.define("infinite-scroll", InfiniteScroll);
 
// ============ FILTER OPEN / CLOSE  ============ //

document.addEventListener("DOMContentLoaded", () => {
  const openBtn = document.querySelector(".desktop_filter_icon");
  const drawer = document.querySelector(".c_filter_drawer");
  const drawerInner = drawer?.querySelector(".collection_drawer-wrapper_inner");
  const body = document.body;
  const html = document.documentElement;

  if (!openBtn || !drawer || !drawerInner) return;

  let lastFocusedElement = null;
  let firstFocusableEl = null;
  let lastFocusableEl = null;

  const focusableSelectors = `
    a[href],
    button:not([disabled]),
    textarea,
    input:not([disabled]),
    select,
    [tabindex]:not([tabindex="-1"])
  `;

  const setFocusableElements = () => {
    const focusables = drawer.querySelectorAll(focusableSelectors);
    firstFocusableEl = focusables[0];
    lastFocusableEl = focusables[focusables.length - 1];
  };

  const openDrawer = () => {
    lastFocusedElement = document.activeElement;

    drawer.classList.add("is-active");
    drawer.removeAttribute("inert");
    drawer.setAttribute("aria-hidden", "false");

    body.setAttribute("data-scroll-locked", "true");
    html.classList.add("lenis-stopped");

    setFocusableElements();
    firstFocusableEl?.focus();

    document.addEventListener("keydown", handleKeydown);
  };

  const closeDrawer = () => {
    drawer.classList.remove("is-active");
    drawer.setAttribute("aria-hidden", "true");
    drawer.setAttribute("inert", "");

    body.removeAttribute("data-scroll-locked");
    html.classList.remove("lenis-stopped");

    lastFocusedElement?.focus();
    document.removeEventListener("keydown", handleKeydown);
  };

  const handleKeydown = (e) => {
    if (e.key === "Escape") {
      closeDrawer();
      return;
    }

    if (e.key !== "Tab") return;

    if (e.shiftKey) {
      // Shift + Tab
      if (document.activeElement === firstFocusableEl) {
        e.preventDefault();
        lastFocusableEl.focus();
      }
    } else {
      // Tab
      if (document.activeElement === lastFocusableEl) {
        e.preventDefault();
        firstFocusableEl.focus();
      }
    }
  };

  // OPEN
  openBtn.addEventListener("click", openDrawer);

  // CLOSE — close button
  drawer.addEventListener("click", (e) => {
    if (e.target.closest(".c_drawer_close")) {
      closeDrawer();
    }
  });

  // CLOSE — backdrop only
  drawer.addEventListener("click", (e) => {
    if (e.target === drawer) {
      closeDrawer();
    }
  });
});


// ============ SORTING  ============ //
class CollectionSorting extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('#main_collection_sorting_form');
    this.select = this.querySelector('select[name="sort_by"]');
    this.sectionId = this.dataset.sectionId;
  }

  connectedCallback() {
    if (!this.select) return;

    this.select.addEventListener('change', () => {
      const value = this.select.value;

      this.showLoader();
      
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', value);
      url.searchParams.set('sections', this.sectionId);

      this.updatePage(url)
        .then(() => this.updateURL(url))
        .finally(() => this.hideLoader());
    });
  }

  showLoader() {
    const loader = document.querySelector('.main_collection_list_wrapper .loader');
    loader?.classList.remove('hidden');
    this.select.disabled = true;
  }

  hideLoader() {
    const loader = document.querySelector('.main_collection_list_wrapper .loader');
    loader?.classList.add('hidden');
    this.select.disabled = false;
  }

  async updatePage(url) {
    try {
      const res = await fetch(url.toString());
      const data = await res.json();

      const temp = document.createElement('div');
      temp.innerHTML = data[this.sectionId];

      const newEl = temp.querySelector('.main_collection');
      const oldEl = document.querySelector('.main_collection');

      if (newEl && oldEl) {
        oldEl.innerHTML = newEl.innerHTML;
        
         requestAnimationFrame(() => {
          if (typeof initProductCardSliders === 'function') {
            initProductCardSliders(oldEl);
          }
        });
      }

      document.dispatchEvent(
        new CustomEvent('collection-grid-update', {
          detail: { url, sectionId: this.sectionId }
        })
      );
    } catch (err) {
      console.error('Collection fetch error:', err);
    }
  }

  updateURL(url) {
    url.searchParams.delete('sections');
    history.pushState({}, '', url.toString());
  }
}

customElements.define('product-sorting', CollectionSorting);

// ============ COLLECTION PRODUCT FILTER  ============ //


class Filters extends HTMLElement {
  constructor() {
    super();
    this.loader = document.querySelector('.main_collection_list_wrapper .loader');
    this.collectionGrid = document.querySelector('.main_collection');
    this.btn = this.querySelector('.filters_btn button');
    this.form = this.querySelector('form#c_filters_form');
    this.drawer = document.querySelector('.c_filter_drawer');
    this.activeValues = this.querySelectorAll('.active_values_wrapper a');
    this.sectionId = this.dataset.sectionId;
  }

  connectedCallback() {
    this.attachListeners();
  }

  attachListeners() {
    if(this.btn) {
      this.btn.addEventListener('click', (e) => {
        e.preventDefault();
        if(!this.form || !this.collectionGrid) return;

        this.showLoader();
        this.submitForm();
      })
    }    

    if(this.activeValues.length) {
    this.activeValues.forEach((value) => {
      value.addEventListener('click', (e) => {
        e.preventDefault();

        this.showLoader();

        const url = new URL(e.currentTarget.getAttribute('href'), window.location.href);

        this.updateURL(url.toString()),
        this.updatePage(url.toString(), this.sectionId);

      })
    })
  }
  }

  showLoader() {
    const loader = document.querySelector('.main_collection_list_wrapper .loader');
    if(loader) {
      loader.classList.remove('hidden');
    }

    if(this.select) {
      this.select.disabled = true;
    }
  }

  hideLoader() {
    const loader = document.querySelector('.main_collection_list_wrapper .loader');
    if(loader) {
      loader.classList.add('hidden');
    }

    if(this.select) {
      this.select.disabled = false;
    }
  }

  async submitForm() {
    const formData = new FormData(this.form);

    const priceGte = this.form.querySelector('[name="filter.v.price.gte"]');
    const priceLte = this.form.querySelector('[name="filter.v.price.lte"]');

    const defaultMin = priceGte?.getAttribute("data-default");
    const defaultMax = priceLte?.getAttribute("data-default");

    if (priceGte && priceLte && defaultMin && defaultMax) {
      if (priceGte.value === defaultMin && priceLte.value === defaultMax) {      
        priceGte.value = "";
        priceLte.value = "";

        formData.delete("filter.v.price.gte");
        formData.delete("filter.v.price.lte");
      }
    }

    const params = new URLSearchParams();

    const currentParams = new URLSearchParams(window.location.search);
    const hasSortBy = formData.has('sort_by');

    for(const [key, value] of currentParams.entries()) {
      if(!key.startsWith('filter.v.') && !key.startsWith('filter.p.')) {
        if(key === 'sort_by' && hasSortBy) {
          continue;
        }
        params.append(key,  value);
      }
    }

    for(const [key, value] of formData.entries()) {
      if(value && value != "") {
        if(key === "sort_by") {
          params.set(key, value);
        } else {
          params.append(key, value);
        }
      }
    }

    const url = `${window.location.pathname}?${params.toString()}`;

    await this.updateURL(url);
    await this.updatePage(url, this.sectionId);



    
  }  

  async updateURL(url) {
    history.pushState(null, "", url);
  }

  async updatePage(url, id) {
    const newURL = url.includes('?')
  ? `${url}&sections=${id}`
  : `${url}?sections=${id}`;
    
    fetch(newURL)
    .then((res) => res.json())
    .then((htmlString) => {

      const temp = document.createElement('div');
      temp.innerHTML = htmlString[id];

      const newWrapper = temp.querySelector('.main_collection');
      const oldWrapper = document.querySelector('.main_collection');

      if(oldWrapper && newWrapper) {
        oldWrapper.innerHTML = newWrapper.innerHTML;

        requestAnimationFrame(() => {
          if (typeof initProductCardSliders === 'function') {
            initProductCardSliders(oldWrapper);
          }
        });

      }

      const newCount = temp.querySelector('.collection_products_count');
      const oldCount = document.querySelector('.collection_products_count');

      if(oldCount && newCount) {
        oldCount.innerHTML = newCount.innerHTML;
      }

      const newMobileDrawer = temp.querySelector('.c_filter_drawer');
      const oldMobileDrawer = this.drawer;

      if(oldMobileDrawer && newMobileDrawer) {
        oldMobileDrawer.innerHTML = newMobileDrawer.innerHTML;
      }

      document.dispatchEvent(
        new CustomEvent('collection-grid-update', {
          detail: {
            url: url,
            sectionId: this.sectionId
          }
        })
      )

    })
    .finally(() => {
       this.hideLoader();
       
    })
  }

}

customElements.define('collection-filters', Filters);



// ============= CALL BACK SCRIPT ON PAGE LOAD AND AJAX  ============= //
document.addEventListener('DOMContentLoaded', () => {
  initProductCardSliders();
});


/* ======================================================================
   LOCALIZATION FORM DROPDWON CODE
====================================================================== */

class LocalizationForm extends HTMLElement {
  constructor() {
    super();

    this.currencyForm = this.querySelector('#currency_selector_form');
    this.languageForm = this.querySelector('#language_selector_form');

    this.currencyBtns = this.querySelectorAll('.currency_list button');
    this.languageBtns = this.querySelectorAll('.language_list button');
  }

  connectedCallback() {
    if(this.currencyBtns.length) {
      this.currencyBtns.forEach((btn) => {
        btn.addEventListener('click', this.handleCurrencyClick.bind(this));
      })
    }

    if(this.languageBtns.length) {
      this.languageBtns.forEach((btn) => {
        btn.addEventListener('click', this.handleLanguageClick.bind(this));
      })
    }    
  }

  handleCurrencyClick(e) {
    const value = e.currentTarget.dataset.value;
    this.querySelector('input[name="country_code"]').value = value;
    return;
    this.currencyForm.submit();
  }

  handleLanguageClick(e) {
    const value = e.currentTarget.dataset.value;
    this.querySelector('input[name="language_code"]').value = value;
    return;
    this.languageForm.submit();
  }
}

customElements.define('localization-form', LocalizationForm);






/* ======================================================================
   RECENTLY VIEWED CODE
====================================================================== */
class RecentlyViewed extends HTMLElement {
  constructor() {
    super();

    this.storageKey = 'recently-viewed-products';
    this.sectionSelector = '[data-recently-viewed]';

    this.currentHandle = this.dataset.productHandle;
    this.maxProducts = Number(this.dataset.columns) || 4;
    this.aspectRatio = this.dataset.aspectRatio || 'portrait';
    this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
  }

  connectedCallback() {
    if (!this.currentHandle) return;

    this.updateRecentlyViewed();
    this.displayRecentlyViewedProducts();
  }

  updateRecentlyViewed() {
    let viewed = JSON.parse(localStorage.getItem(this.storageKey)) || [];

    viewed = viewed.filter(handle => handle !== this.currentHandle);
    viewed.unshift(this.currentHandle);

    if (viewed.length > this.maxProducts) {
      viewed = viewed.slice(0, this.maxProducts);
    }

    localStorage.setItem(this.storageKey, JSON.stringify(viewed));
  }

  async displayRecentlyViewedProducts() {
    const section = document.querySelector(this.sectionSelector);
    if (!section) return;

    const handles = JSON.parse(localStorage.getItem(this.storageKey)) || [];

    if (!handles.length) {
      section.style.display = 'none';
      return;
    }

    try {
      const products = await Promise.all(
        handles.map(handle =>
          fetch(`/products/${handle}.js`).then(res => res.json())
        )
      );

      section.innerHTML = `
        <div class="recently_viewed_inner">
          ${products.map(product => this.renderProductCard(product)).join('')}
        </div>
      `;
    } catch (error) {
      console.error('Recently Viewed error:', error);
      section.style.display = 'none';
    }
  }

  renderProductCard(product) {
    if (!product) return '';

    const variant = product.variants[0];
    const price = variant.price;
    const compareAt = variant.compare_at_price;
    const hasSale = compareAt && compareAt > price;

    const image = product.images?.[0] || "";

    let ratio = 100;
    if (this.aspectRatio === 'portrait') ratio = 140;
    if (this.aspectRatio === 'square') ratio = 100;
    if (this.aspectRatio === 'adapt' && image) {
      ratio = 100;
    }

    return `
      <div class="recently_viewed_product">
        <div class="recently_viewed_product_img ratio" style="--aspect-ratio:${ratio}%">
          <a href="/products/${product.handle}" aria-label="${product.title}">
            ${image ? `<img src="${image}" alt="${product.title}" loading="lazy">` : ''}
          </a>
        </div>

        <div class="recently_viewed_product_info">
          <p>
            <a aria-label="${product.title}" href="/products/${product.handle}">${product.title}</a>
          </p>

          <div class="recently_viewed_product_price">
            <span class="${hasSale ? 'sale_p' : 'regular'}">
              ${Shopify.formatMoney(price, this.moneyFormat)}
            </span>
            ${hasSale ? `<s>${Shopify.formatMoney(compareAt, this.moneyFormat)}</s>` : ''}
          </div>
        </div>
      </div>
    `;
  }
}

customElements.define('recently-viewed', RecentlyViewed);

/* ======================================================================
   Composite Promotion Hub 
====================================================================== */
class PromoHub extends HTMLElement {
  constructor() {
    super();
    this.activeIndex = -1;
  }

  connectedCallback() {
    this.blocks = [...this.querySelectorAll('.promo-hub-block')];
    this.backgrounds = [...this.querySelectorAll('.promo-hub-bg')];
    this.grid = this.querySelector('.promo-hub-grid');

    if (!this.blocks.length) return;

    /* Desktop interactions only */
    ['pointerover', 'focusin', 'mouseleave', 'keydown'].forEach((type) =>
      this.addEventListener(type, this)
    );

    /* Mobile: activate slide only after user scrolls */
    this.grid?.addEventListener(
      'scroll',
      () => {
        if (!this.isMobile()) return;

        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => this.setActiveSlide(), 60);
      },
      { passive: true }
    );
  }

  isMobile() {
    return window.innerWidth <= 749;
  }

  handleEvent(event) {
    const block = event.target.closest('.promo-hub-block');

    /* Disable hover/focus behavior on mobile */
    if (this.isMobile() && event.type !== 'keydown') return;

    if (event.type === 'mouseleave') {
      this.reset();
      return;
    }

    if (event.type === 'keydown') {
      this.onKeyDown(event, block);
      return;
    }

    if (block && this.contains(block)) {
      this.activate(this.blocks.indexOf(block));
    }
  }

  onKeyDown(event, block) {
    if (!block) return;

    if (event.key === 'Escape') {
      this.reset();
      block.blur();
      return;
    }

    const move = {
      ArrowRight: 1,
      ArrowLeft: -1,
      ArrowDown: 1,
      ArrowUp: -1
    }[event.key];

    if (!move) return;

    const current = this.blocks.indexOf(block);
    const next = current + move;

    if (next < 0 || next >= this.blocks.length) return;

    event.preventDefault();
    this.blocks[next].focus();

    if (this.isMobile()) {
      this.blocks[next].scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      });
    }
  }

  activate(index) {
    if (index < 0 || index === this.activeIndex) return;

    this.activeIndex = index;
    this.classList.add('has-hover');

    this.blocks.forEach((block, i) => {
      const active = i === index;

      block.classList.toggle('is-active', active);
      block.setAttribute('aria-current', active ? 'true' : 'false');

      this.backgrounds[i]?.classList.toggle('is-active', active);
    });
  }

  setActiveSlide() {
    if (!this.grid || !this.blocks.length) return;

    const gridRect = this.grid.getBoundingClientRect();
    const center = gridRect.left + gridRect.width / 2;

    let closestIndex = 0;
    let minDistance = Infinity;

    this.blocks.forEach((block, index) => {
      const rect = block.getBoundingClientRect();
      const blockCenter = rect.left + rect.width / 2;
      const distance = Math.abs(center - blockCenter);

      if (distance < minDistance) {
        minDistance = distance;
        closestIndex = index;
      }
    });

    this.activate(closestIndex);
  }

  reset() {
    /* Desktop only reset */
    if (this.isMobile()) return;

    this.activeIndex = -1;
    this.classList.remove('has-hover');

    this.blocks.forEach((block, i) => {
      block.classList.remove('is-active');
      block.setAttribute('aria-current', 'false');

      /* Keep first background visible */
      this.backgrounds[i]?.classList.toggle('is-active', i === 0);
    });
  }
}

if (!customElements.get('promo-hub')) {
  customElements.define('promo-hub', PromoHub);
}

/* ======================================================================
   Scrolling Image Text
====================================================================== */
class ScrollingImageText extends HTMLElement {
  constructor() { super(); this.curr = this.targ = 0; }

  connectedCallback() {
    this.setup = { start:1.1, end: 0.4, back: 0.4, smooth: 0.020 };
       // Start 1.0 = starts at bottom of screen. Increase to start earlier.
       // End 0.0 = finishes at top of screen. Decrease to finish later.
       // back Amount of "overshoot" bounce. 0.1 is subtle, 0.3 is bouncy.
       // smooth Inertia/Smoothness. 0.03 is very heavy/fluid, 0.1 is fast.
    this.init();
    this.obs = new IntersectionObserver(e => {
      this.active = e[0].isIntersecting;
      if (this.active) { this.snap = true; this.render(); }
    });
    this.obs.observe(this);
  }

  init() {
    this.querySelectorAll('[data-parallax-x], [data-parallax-rotate]').forEach(el => {
      if (el.dataset.parallaxX) el.style.setProperty('--parallax-x', el.dataset.parallaxX);
      if (el.dataset.parallaxRotate) el.style.setProperty('--parallax-rotate', el.dataset.parallaxRotate);
    });
  }

  render() {
    if (!this.active) return;

    const rect = this.getBoundingClientRect();
    const winH = window.innerHeight;
    const startPoint = winH * this.setup.start;
    const endPoint = winH * this.setup.end;
    
    // Calculate progress
    this.targ = Math.min(Math.max((startPoint - rect.top) / (startPoint - endPoint), 0), 1);
    
    // Smooth or Snap
    this.curr = this.snap ? this.targ : this.curr + (this.targ - this.curr) * this.setup.smooth;
    this.snap = false;

    // Apply Easing (Overshoot)
    const c1 = this.setup.back;
    const eased = 1 + (c1 + 1) * Math.pow(this.curr - 1, 3) + c1 * Math.pow(this.curr - 1, 2);

    this.style.setProperty('--parallax-progress', eased);
    requestAnimationFrame(() => this.render());
  }

  disconnectedCallback() { if (this.obs) this.obs.disconnect(); }
}

if (!customElements.get('scrolling-image-text')) {
  customElements.define('scrolling-image-text', ScrollingImageText);
}
